import Duck from 'extensible-duck';
import Cookie from 'js-cookie';
import toast from 'simple-pure-toast';
import { Auth } from 'aws-amplify';
import {
  getCanalById,
  getCurrentLiteralRoleType,
  getRolById,
  handlerRequestErrors,
  msjCommon,
  removeFederationName,
  statusesCommon,
  typesCommon
} from '../../utils/helpers';
import { get } from '../../utils/request';

const EXPIRATION_COOKIE = 60;

const initialState = {
  rolActual: null,
  canalActual: null,
  message: '',
  status: '',
  user: {
    userId: '',
    codigoSap: '',
    nombreCorto: '',
    nombreLargo: ''
  },
  rol: {
    jefe: 'G_USR_POWERRIMAC_JEFE',
    supervisor: 'G_USR_POWERRIMAC_SUPER',
    asesor: 'G_USR_POWERRIMAC_ASESOR'
  },
  configuracion: {
    MENU: {},
    SECCION_TITULO: {},
    ACCION_DEEP: {
      cierre: [],
      creacion: []
    },
    TABLA: {
      columnasTablaEquipo: []
    },
    META: {}
  }
};

const getInitialState = ({ statuses }) => ({
  ...initialState,
  status: statuses.NEW
});

const obtenerInformacionUsuario = async (correo) => {
  const respuesta = await get(`/personas/${correo}`);
  return respuesta.payload;
}

export default new Duck({
  namespace: 'converti',
  store: 'auth',
  consts: {
    statuses: [
      ...statusesCommon,
      'LOADING_FEDERATE',
      'LOGIN',
      'LOGOUT',
      'SAVE',
      'LOADING_CONFIGURATION',
      'READY_CONFIGURATION'
    ]
  },
  types: [
    ...typesCommon,
    'SIGNIN_PENDING',
    'SIGNIN_FULLFILLED',
    'SINGOUT_PENDING',
    'SINGOUT_FULLFILLED',
    'CHANGEPASSWORD_PENDING',
    'CHANGEPASSWORD_FULLFILLED',
    'SIGNIN_FEDERATE_PENDING',
    'HYDRATE_AUTH',
    'AUTH_RESET',
    'AUTH_FAILD',
    'FALSE_AUTH_FEDERATE',
    'FETCH_PENDING_CONFIGURATION',
    'FETCH_FULLFILLED_CONFIGURATION',
    'RESET_AUTH_DUCK'
  ],
  initialState: getInitialState,
  reducer: (state, action, { types, statuses, initialState }) => {
    switch (action.type) {
      case types.SIGNIN_PENDING:
      case types.SINGOUT_PENDING:
      case types.CHANGEPASSWORD_PENDING:
        return {
          ...state,
          status: statuses.LOADING
        };

      case types.SIGNIN_FEDERATE_PENDING:
        return {
          ...state,
          status: statuses.LOADING_FEDERATE
        };

      case types.SIGNIN_FULLFILLED:
        const expires = new Date(
          new Date().getTime() + EXPIRATION_COOKIE * 60 * 1000
        );
        Cookie.set('POWERIMAC_ROL', action.payload.rolActual, { expires });
        Cookie.set('POWERIMAC_CANAL', action.payload.canalActual, { expires });
        window.sessionStorage.removeItem('federateLogin');
        window.localStorage.removeItem('amplify-redirected-from-hosted-ui');
        window.localStorage.removeItem('amplify-signin-with-hostedUI');
        toast.success(msjCommon('listo'), {
          description: 'Inicio de sesión completo',
          position: 'bottomRight'
        });
        return {
          ...state,
          ...action.payload,
          status: statuses.LOGIN
        };

      case types.SINGOUT_FULLFILLED:
        Cookie.remove('POWERIMAC_ROL');
        Cookie.remove('POWERIMAC_CANAL');
        return {
          ...initialState,
          status: statuses.LOGOUT
        };

      case types.CHANGEPASSWORD_FULLFILLED:
        toast.success('', {
          description: 'Contraseña cambiada correctamente',
          position: 'bottomRight'
        });
        return {
          ...state,
          status: statuses.SAVE
        };

      case types.HYDRATE_AUTH:
        return {
          ...state,
          ...action.payload,
          status: statuses.LOGIN
        };

      case types.AUTH_RESET:
        return initialState;

      case types.FALSE_AUTH_FEDERATE:
        window.sessionStorage.removeItem('federateLogin');
        toast.error(msjCommon('fallo'), {
          description: action.payload.message,
          position: 'bottomRight'
        });
        return {
          ...state,
          status: statuses.NEW
        };

      case types.FETCH_PENDING_CONFIGURATION:
        return {
          ...state,
          configuracion: {
            MENU: {},
            SECCION_TITULO: {},
            ACCION_DEEP: {
              cierre: [],
              creacion: []
            },
            TABLA: {
              columnasTablaEquipo: []
            },
            META: {}
          },
          status: statuses.LOADING_CONFIGURATION
        };

      case types.FETCH_FULLFILLED_CONFIGURATION:
        return {
          ...state,
          ...action.payload,
          status: statuses.READY_CONFIGURATION
        };

      case types.AUTH_FAILD:
      case types.CREATOR_FAILD:
        toast.error(msjCommon('fallo'), { description: action.payload.message, position: 'bottomRight' });
        return { ...state, status: statuses.ERROR };

      case types.RESET_AUTH_DUCK:
        return getInitialState({ statuses });

      default:
        return state;
    }
  },
  selectors: {
    root: (state) => state
  },
  creators: ({ types }) => ({
    signIn: ({ username, password }) => async (dispatch) => {
      dispatch({ type: types.SIGNIN_PENDING });
      const userWithError = Cookie.get(username);
      const userWithErrorAsJson = userWithError ? JSON.parse(userWithError) : {};
      if (userWithErrorAsJson.failedAttempts >= 3) {
        dispatch({
          type: types.AUTH_FAILD,
          payload: { message: 'Se excedió el número de intentos fallidos, por favor intente en un minuto' }
        });
      } else {
        Auth.signIn({ username, password })
          .then(async (data) => {
            const {
              username: userId,
              attributes: { name },
              signInUserSession: { accessToken: { payload } = {} } = {}
            } = data;
            const correo = removeFederationName(userId);
            const usuario = await obtenerInformacionUsuario(correo);

            dispatch({
              type: types.SIGNIN_FULLFILLED,
              payload: {
                rolActual: getRolById(payload['cognito:groups']),
                canalActual: getCanalById(payload['cognito:groups']),
                user: {
                  userId: correo,
                  codigoSap: usuario.codigoSap,
                  nombreLargo: name,
                  nombreCorto: usuario.nombreCorto
                }
              }
            });
          })
          .catch((e) => {
            const { message } = handlerRequestErrors(e, username);
            dispatch({
              type: types.AUTH_FAILD,
              payload: { message: message || '' }
            });
            localStorage.clear();
          });
      }
    },
    signOut: () => async (dispatch) => {
      try {
        dispatch({ type: types.SINGOUT_PENDING });

        await Auth.signOut();
        dispatch({ type: types.SINGOUT_FULLFILLED });

        localStorage.clear();
      } catch (e) {
        const { message = '' } = handlerRequestErrors(e);
        dispatch({ type: types.AUTH_FAILD, payload: { message } });
      }

    },
    signInFederate: () => async (dispatch) => {
      dispatch({ type: types.SIGNIN_FEDERATE_PENDING });
      Auth.currentSession()
        .then(async (data) => {
          const {
            idToken: { payload = {} }
          } = data;
          const correo = removeFederationName(payload['cognito:username']);
          const usuario = await obtenerInformacionUsuario(correo);
          dispatch({
            type: types.SIGNIN_FULLFILLED,
            payload: {
              rolActual: getRolById(payload['cognito:groups']),
              canalActual: getCanalById(payload['cognito:groups']),
              user: {
                userId: correo,
                codigoSap: usuario.codigoSap,
                nombreLargo: payload.name,
                nombreCorto: usuario.nombreCorto

              }
            }
          });
        })
        .catch(() => {
          dispatch({
            type: types.FALSE_AUTH_FEDERATE,
            payload: { message: 'No se pudo obtener las credenciales.' }
          });
        });
    },
    hydrateAuth: () => async (dispatch) => {
      Auth.currentAuthenticatedUser()
        .then(async (data) => {
          const {
            username: userId,
            attributes: { name }
          } = data;
          const correo = removeFederationName(userId);
          const usuario = await obtenerInformacionUsuario(correo);
          dispatch({
            type: types.HYDRATE_AUTH,
            payload: {
              rolActual: Cookie.get('POWERIMAC_ROL'),
              canalActual: Cookie.get('POWERIMAC_CANAL'),
              user: {
                userId: correo,
                codigoSap: usuario.codigoSap,
                nombreLargo: name,
                nombreCorto: usuario.nombreCorto
              }
            }
          });
        })
        .catch((e) => {
          const { message = '' } = handlerRequestErrors(e);
          dispatch({ type: types.AUTH_FAILD, payload: { message } });
        });
    },
    changePassword: ({ username, password, newPassword }) => async (
      dispatch
    ) => {
      try {
        dispatch({ type: types.CHANGEPASSWORD_PENDING });
        await Auth.signIn({ username, password });
        const user = await Auth.currentAuthenticatedUser();
        const response = await Auth.changePassword(user, password, newPassword);
        if (response === 'SUCCESS') {
          await Auth.signOut();
          dispatch({ type: types.CHANGEPASSWORD_FULLFILLED });
        } else {
          throw Error('');
        }
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({
          type: types.AUTH_FAILD,
          payload: { message: message || '' }
        });
      }
    },
    authReset: () => async (dispatch) => {
      dispatch({ type: types.AUTH_RESET });
    },
    faildAuthFederate: () => async (dispatch) => {
      dispatch({
        type: types.FALSE_AUTH_FEDERATE,
        payload: { message: 'No se pudo iniciar sesión, Error en federado' }
      });
    },
    getConfiguration: () => async (dispatch, getState) => {
      const { auth: { rol, rolActual } } = getState();
      const canal = Cookie.get('POWERIMAC_CANAL');
      try {
        dispatch({ type: types.FETCH_PENDING_CONFIGURATION });
        const { payload } = await get(`/canales/${canal}/configuraciones?rol=${getCurrentLiteralRoleType(rolActual, rol)}`);
        localStorage.setItem('POWERRIMAC_CONFIGURACION', JSON.stringify(payload));
        dispatch({
          type: types.FETCH_FULLFILLED_CONFIGURATION,
          payload: {
            configuracion: JSON.parse(localStorage.getItem('POWERRIMAC_CONFIGURACION'))
          }
        });
      } catch (e) {
        const { message } = handlerRequestErrors(e);
        dispatch({ type: types.CREATOR_FAILD, payload: { message: message || '' } });
      }
    },
    resetAuthDuck: () => async (dispatch) => {
      dispatch({ type: types.RESET_AUTH_DUCK });
    }

  })
});
